"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MTGFuturesRenewRound = exports.botFuturesAI = exports.MTGFuturesParamsCheck = exports.MTGFuturesMarginSettingCheckAPI = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
// 合约马丁 调整保证金预检查
function MTGFuturesMarginSettingCheckAPI(req) {
    const { orderId } = req, params = __rest(req, ["orderId"]);
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = `${host}/futures_martingale/${orderId}/margin_transfer_check/`;
    return trade_utils_lib_1.Network.post({ url, data: params, authType: trade_utils_lib_1.AuthType.Access });
}
exports.MTGFuturesMarginSettingCheckAPI = MTGFuturesMarginSettingCheckAPI;
// 合约马丁下单预检查
function MTGFuturesParamsCheck(req) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = `${host}/futures_martingale/check/`;
    return trade_utils_lib_1.Network.post({ url, data: req, authType: trade_utils_lib_1.AuthType.Access });
}
exports.MTGFuturesParamsCheck = MTGFuturesParamsCheck;
// 合约马丁AI参数
function botFuturesAI(request, orderType) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost;
    const url = host + `/${orderType}/ai_strategy/`;
    return trade_utils_lib_1.Network.get({ url: url, data: request });
}
exports.botFuturesAI = botFuturesAI;
// 合约马丁重置轮次
function MTGFuturesRenewRound(request, orderType) {
    const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/${orderType}/${request.orderId}/renew_round/`;
    return trade_utils_lib_1.Network.post({ url: url, data: request, authType: trade_utils_lib_1.AuthType.Access });
}
exports.MTGFuturesRenewRound = MTGFuturesRenewRound;
